(function($)
{
    $.extend(true, orion, {
        api: {
            orderlist: {}
        }
    });

    var
        api = orion.api.orderlist,
        uri = '/api-orderlist';

    function read()
    {
        var promise = $.ajax(uri, {
            method: 'GET'
        });

        return promise;
    }

    function readItems(orderlistId, skip, take)
    {
        var promise = $.ajax(uri + '/' + orderlistId + '/items', {
            method: 'GET',
            data: {
                skip: skip,
                take: take,
                draw: 0,
                order: {
                    0: {
                        field: 'productNumber',
                        dir: 'asc'
                    }
                }
            },
            headers: {
                Accept: 'application/json'
            }
        });

        return promise;
    }

    api.read = read;
    api.readItems = readItems;
})(jQuery);
